/* ============================================================================================
 * LA TAILLE PERSONNALISEE, SUR LES AFFICHES DU CATALOGUE (Adrien, 20/08/2026).
 *
 * « Ajoute une option de taille personnalisee pour les formats, a droite de 100x140. Il n'y a
 * pas de choix de cadre : a la place des cadres, il faut mettre un selecteur de longueur et
 * largeur. »
 *
 * ⛔ LE PRIX NE SE CALCULE PAS ICI. Le plancher de marge se calcule sur la grille de couts du
 * Studio, qui n'a rien a faire dans un fichier telecharge par le navigateur. Ce script pose une
 * question a `runway` et affiche la reponse. Il ne connait ni les couts, ni la regle, ni meme la
 * grille de prix de la fiche : le serveur la relit chez Shopify pour que personne ne puisse la
 * lui dicter.
 *
 * ⛔ ET LA LIGNE DE PANIER PART SUR UN PRODUIT-SUPPORT A PALIERS. Une cote libre n'aura jamais
 * de variante Shopify ; « Tirage sur mesure » porte 95 paliers de prix, et l'affiche reelle
 * voyage en proprietes de ligne (`_sm_produit`, `_sm_l`, `_sm_h`), que le webhook relit pour
 * ranger la vente sous la bonne affiche. C'est exactement le dessin du B2B catalogue.
 *
 * ⛔⛔ ET L'AFFICHE SE DESIGNE PAR SON IDENTIFIANT NUMERIQUE, JAMAIS PAR SON HANDLE. Markets
 * TRADUIT les handles : celui que cette page connait sur le marche allemand n'existe pas dans
 * l'API Admin. Ma premiere version envoyait le handle, et elle aurait echoue de deux facons a
 * la fois sans lever une erreur : 404 sur la route de prix pour douze marches sur treize, et
 * une vente journalisee sous un nom qu'aucun ecran ne rapproche de l'affiche.
 * ========================================================================================== */
(function () {
  var bloc = document.getElementById("pdp-sur-mesure");
  var pastille = document.querySelector("[data-sur-mesure]");
  if (!bloc || !pastille) return;

  var champL = document.getElementById("pdp-sm-l");
  var champH = document.getElementById("pdp-sm-h");
  var sortie = document.getElementById("pdp-sm-prix");
  var cadre = document.getElementById("pdp-up-frame");
  var MIN = parseInt(bloc.getAttribute("data-min"), 10) || 20;
  var MAX = parseInt(bloc.getAttribute("data-max"), 10) || 100;
  var URL_PRIX = bloc.getAttribute("data-prix-url") || "";
  var PRODUIT = bloc.getAttribute("data-produit") || "";

  var actif = false;
  var prixTtc = null;
  var tour = 0;
  /* Le cadrage choisi par le client, en fractions de l'image. Le centre par defaut : c'est ce
     que dit la note sous le panneau, et ce que fait la presse quand rien n'a ete choisi. */
  var cadrage = { x: 0.5, y: 0.5 };
  var panneau = null;
  var appliquer = null;
  var avantPanneau = null;
  var actualiseCouche = null;
  var fermeturePanneau = 0;
  var scrollPanneau = null;
  var libelleCotes = null;
  var texteCotes = '';
  var bordure = document.getElementById('pdp-up-bordure');
  var placeBordure = null;
  var panneauDisponible = !!bloc.closest('.pdp-buy--catalogue') && !!bloc.dataset.sheetApply &&
    typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function';

  /* ══════════ LA GALERIE, PENDANT UNE COTE LIBRE ══════════
     ⛔ LE RAPPORT D'ORIGINE SE GARDE, IL NE SE DEVINE PAS. `--art-ratio` est pose EN LIGNE par
     le gabarit, et il vaut le rapport de CETTE oeuvre : une affiche couchee ne vit pas a
     0,6923. Le retirer pour « revenir a la normale » rendrait la valeur par defaut de la
     feuille de style, donc une affiche portrait sur un produit paysage. On memorise donc ce
     que le gabarit a ecrit, et on le remet mot pour mot. */
  var galerie = document.querySelector(".pdp-gallery__wrap");
  var piece = document.getElementById("pdp-mockup");
  var ratioGalerie = galerie ? galerie.style.getPropertyValue("--art-ratio") : "";
  var ratioPiece = piece ? piece.style.getPropertyValue("--art-ratio") : "";

  function borne(v) {
    var n = Math.round(Number(v));
    if (!isFinite(n)) return null;
    return Math.max(MIN, Math.min(MAX, n));
  }

  /* ⛔⛔ UN SEUL FORMAT DE PRIX SUR CE SITE, ET IL N'EST PAS ICI. `MURMURE_MONEY` applique le
     format monetaire regle dans Shopify, celui que voient deja le panier, les e-mails et le
     paiement, et il vaut pour les treize langues sans qu'on ait a decider ou placer le symbole
     dans chacune. J'avais ecrit un SECOND format, avec l'euro en dur : c'est exactement le
     defaut mesure le 06/08/2026, ou Liquid rendait « €10,13 » et le JS « 10,13 € » sur la meme
     page, le prix barre partant vers la droite sous les yeux du client. `theme.liquid` le dit
     en toutes lettres : « Ne recodez pas un format ici. » */
  /* La conversion vit dans `layout/theme.liquid`, a cote du format monetaire : un seul endroit
     pour les deux, sinon ils divergent. Le repli n'existe que si le gabarit n'a pas ete servi. */
  function enDevise(centsEuro) {
    if (typeof window.MURMURE_EN_DEVISE === "function") return window.MURMURE_EN_DEVISE(centsEuro);
    return centsEuro;
  }
  /* ⛔⛔ CE PRIX EST CALCULE PAR NOTRE SERVEUR, EN EUROS, ET LE PANIER LE FACTURERA EN MONNAIE
     LOCALE. Sans conversion, le format du marche habillait un montant en euros du symbole du
     pays : mesure du 21/08/2026 sur /cs-eun/, un 60 × 90 annonce « 31,00 Kč » pour 765 Kč
     factures. Vingt-cinq fois moins cher a l'ecran que sur la facture, sans aucune erreur.
     ⚠️ ET C'EST LA MEME REGLE QUE LE PALIER SUIVRA AU PANIER : le palier est un produit Shopify,
     converti par Shopify. On applique donc la conversion de la boutique, pas la notre. */
  function argent(eur) {
    var cents = enDevise(Math.round(eur * 100));
    if (typeof window.MURMURE_MONEY === "function") return window.MURMURE_MONEY(cents);
    return (cents / 100).toLocaleString(document.documentElement.lang || "fr-FR",
      { minimumFractionDigits: 2 }) + "\u00a0€";
  }

  /* ⛔ LE LIBELLE DU BOUTON RESTE CELUI DU THEME. On ne fabrique pas une phrase de prix ici :
     `product.js` ecrit deja « Ajouter au panier · 24,20 € » dans la langue du marche, et une
     seconde ecriture serait celle qu'on oublie de traduire. */
  function majBouton() {
    if (appliquer) appliquer.disabled = prixTtc === null || !champL.checkValidity() || !champH.checkValidity();
    var b = document.getElementById("pdp-add");
    var st = document.getElementById("pdp-sticky-add");
    if (!b || !st) return;
    var ajouter = st.getAttribute("data-label-add");
    if (!ajouter) return;
    if (!actif) return;
    b.textContent = prixTtc === null ? ajouter : ajouter + " · " + argent(prixTtc);
    var prixPrincipal = document.getElementById('pdp-price');
    var prixBarre = document.getElementById('pdp-compare');
    var badgePromo = document.getElementById('pdp-sale-badge');
    if (prixPrincipal) prixPrincipal.textContent = prixTtc === null ? '…' : argent(prixTtc);
    var prixSticky = document.getElementById('pdp-sticky-price');
    if (prixSticky) prixSticky.textContent = prixTtc === null ? '…' : argent(prixTtc);
    if (prixBarre) prixBarre.hidden = true;
    if (badgePromo) badgePromo.hidden = true;
  }

  /* ⚠️ UNE QUESTION PAR SAISIE STABILISEE, PAS PAR TOUCHE. Trois chiffres tapes, c'est trois
     requetes dont deux perimees ; et un jeton garde la derniere reponse contre l'ordre d'arrivee,
     comme la fenetre de rendu le fait pour ses compositions. */
  var minuteur = 0;
  function demandePrix() {
    clearTimeout(minuteur);
    var mien = (tour += 1);
    prixTtc = null;
    majBouton();
    minuteur = setTimeout(function () {
      var l = borne(champL.value);
      var h = borne(champH.value);
      if (l === null || h === null || !URL_PRIX || !PRODUIT) return;
      sortie.setAttribute("data-etat", "attente");
      sortie.textContent = '…';
      fetch(URL_PRIX, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ produit: PRODUIT, l: l, h: h }),
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (rep) {
          if (mien !== tour) return;
          if (!rep.ok || typeof rep.j.prixTtc !== "number") {
            prixTtc = null;
            sortie.setAttribute("data-etat", "echec");
            sortie.textContent = bloc.getAttribute('data-echec') || '';
            majBouton();
            return;
          }
          prixTtc = rep.j.prixTtc;
          sortie.setAttribute("data-etat", "ok");
          sortie.textContent = l + " × " + h + " cm · " + argent(prixTtc);
          majBouton();
        }).catch(function () {
          if (mien !== tour) return;
          prixTtc = null;
          sortie.setAttribute("data-etat", "echec");
          sortie.textContent = bloc.getAttribute('data-echec') || '';
          majBouton();
        });
    }, 260);
  }

  /* ⛔ L'APERCU DU RECADRAGE, LA CONTREPARTIE DE L'EXCEPTION DE RATIO (Adrien, 20/08/2026 :
     « Exception + apercu du recadrage a l'ecran »). Le fichier vit en 0,6923 et aucune cote
     libre n'est a ce rapport : sur mesure, l'image remplit sa zone et se fait rogner. Le client
     voit donc ce qu'il perd AVANT de payer.

     ⚠️ ON MONTRE L'OEUVRE ENTIERE AVEC SA FENETRE D'IMPRESSION, pas l'image deja rognee :
     l'image rognee cache exactement ce qu'on veut faire voir. Ce qui est hors fenetre part a la
     coupe, et la perte est chiffree en centimetres a cote.

     ⚠️ LE MEME CALCUL QUE LA PRESSE, A L'ENVERS. `print.js` pose l'image en « cover » dans la
     zone interieure : la fenetre est donc le plus grand rectangle au rapport demande qui tienne
     dans l'oeuvre. Un apercu qui calculerait autrement promettrait un cadrage que le papier ne
     tiendrait pas. */
  var vue = bloc.querySelector(".pdp-sm__vue");
  var fenetre = bloc.querySelector(".pdp-sm__fenetre");
  var perte = document.getElementById("pdp-sm-perte");
  var RATIO_ART = parseFloat(bloc.getAttribute("data-ratio")) || 0.6923;
  if (vue) {
    var img = bloc.getAttribute("data-apercu");
    if (img) vue.style.backgroundImage = "url('" + img + "')";
    vue.style.setProperty("--sm-art", String(RATIO_ART));
  }

  function zone(l, h) {
    var B = window.AfBordure;
    var m = B && B.choisi === 'avec' && B.offert ? B.margeMm('SM:' + l + 'X' + h) / 10 : 0;
    var interieurL = l - 2 * m, interieurH = h - 2 * m;
    var vise = interieurL / interieurH;
    var fw = vise > RATIO_ART ? 1 : vise / RATIO_ART;
    var fh = vise > RATIO_ART ? RATIO_ART / vise : 1;
    return {fw:fw,fh:fh,l:interieurL,h:interieurH,m:m,cx:Math.min(Math.max(cadrage.x,fw/2),1-fw/2),cy:Math.min(Math.max(cadrage.y,fh/2),1-fh/2)};
  }
  window.AfSurMesure = {
    rafraichirPrix: majBouton,
    format: function() { return actif ? 'SM:' + borne(champL.value) + 'X' + borne(champH.value) : ''; },
    position: function(l,h) {
      l = l || borne(champL.value); h = h || borne(champH.value);
      var z=zone(l,h);
      return (z.fw<1?(z.cx-z.fw/2)/(1-z.fw)*100:50)+'% '+(z.fh<1?(z.cy-z.fh/2)/(1-z.fh)*100:50)+'%';
    }
  };

  function majApercu(l, h) {
    if (!vue || !fenetre) return;
    var z = zone(l,h);
    /* Plus large que l'oeuvre : la fenetre prend toute la largeur et se rogne en hauteur.
       Plus etroite : l'inverse. C'est « cover », vu depuis l'image. */
    var fw = z.fw;
    var fh = z.fh;
    fenetre.style.setProperty("--sm-w", String(fw));
    fenetre.style.setProperty("--sm-h", String(fh));
    /* ⛔ ET ELLE SE POSE OU LE CLIENT L'A LAISSEE. Une fenetre toujours centree ici pendant que
       la presse decentre, ce sont deux images differentes pour la meme commande, et c'est
       l'apercu qui aurait menti. Les bornes sont les memes des deux cotes. */
    var cx = z.cx;
    var cy = z.cy;
    fenetre.style.setProperty("--sm-x", String(cx));
    fenetre.style.setProperty("--sm-y", String(cy));
    /* ⛔ UN SEUL CALCUL POUR LES DEUX ECRANS. La vignette et la galerie doivent montrer la
       MEME fenetre : deux calculs separes divergeraient au premier ajustement, et le client
       verrait deux cadrages pour une seule commande. */
    galerieSuit(l, h, fw, fh, cx, cy);
    if (!perte) return;
    /* La perte se dit dans l'unite du client : des centimetres de SON tirage, pas un
       pourcentage de pixels. Sous un demi-centimetre, on ne dit rien : annoncer « 0 cm rognes »
       inquiete pour une coupe que personne ne verra. */
    var cm = fh < 1 ? (z.h * (1 - fh)) : (z.l * (1 - fw));
    /* ⛔ DEUX PHRASES ENTIERES, PAS UNE PHRASE ET UN MORCEAU. Coller « en hauteur » a la fin
       d'un modele marche en francais et casse ailleurs : l'ordre des mots, l'accord et la place
       du nombre changent d'une langue a l'autre. Chaque langue ecrit sa phrase complete. */
    var modele = bloc.getAttribute(fh < 1 ? "data-perte-h" : "data-perte-l") || "";
    /* ⚠️ ET LE NOMBRE SE FORMATE DANS LA LANGUE DU MARCHE. `toFixed` rend toujours un POINT :
       « 6.7 cm » au milieu d'une phrase francaise, et le meme defaut dans neuf des treize
       langues. Le prix, lui, passe deja par `toLocaleString` a deux lignes de la. */
    var arrondi = Math.round(cm * 10) / 10;
    perte.textContent = cm < 0.5 || !modele ? ""
      : modele.replace("{cm}", arrondi.toLocaleString(document.documentElement.lang || "fr-FR"));
  }

  /* ⛔ LE CADRE CHOISI SE RETIRE, IL NE SE CACHE PAS (Adrien, 22/08/2026 : « le cadre est
     herite quand on l'a coche et qu'on va dans la vue sur mesure, du coup le ratio du cadre et
     les cotes sont fausses »). Cacher `#pdp-up-frame` retirait le CHOIX, pas le cadre deja
     retenu : la galerie gardait sa baguette, dessinee au rapport d'un format standard, et les
     cotes de ce format-la. Le client lisait « 50 x 70 » sur une affiche demandee en 43 x 50.

     ⚠️ ON RECLIQUE LA MOULURE ACTIVE, le geste que la fiche offre deja : il vide `upColor`,
     efface l'apercu, retire le lien « voir le cadre » et sort la ligne du panier. Refaire tout
     cela a la main dupliquerait quatre etats qui vivent dans une fermeture de product.js.

     ⚠️ ET AVANT DE DESELECTIONNER LES FORMATS : le clic est ignore tant qu'aucun format n'est
     choisi (`cadreAutorise`). L'ordre des deux gestes n'est pas cosmetique. */
  function retireLeCadre() {
    var m = document.querySelector('#pdp-up-frame .pdp-up-color[aria-pressed="true"]');
    if (m) m.click();
  }

  /* Les cotes s'ecrivent comme celles des formats standard : virgule decimale, unite collee.
     Voir `cmLabel` dans product.js, qui fait le meme geste pour A_CM. */
  function cmTexte(n) { return String(n).replace(".", ",") + " cm"; }

  /**
   * LA GALERIE PREND LA COTE DEMANDEE.
   *
   * ⛔ SANS CELA ELLE MONTRE LE FORMAT PRECEDENT (Adrien : « l'affiche de la galerie doit
   * s'adapter a ce que choisi le client »). La pastille « Sur mesure » n'a pas de variante :
   * `product.js` ne la voit jamais passer, garde son dernier format dans `selected`, et laisse
   * donc la scene au rapport et aux cotes de celui-la.
   *
   * ⚠️ LE MEME CADRAGE QUE L'APERCU, RECALCULE POUR UN FOND « cover ». Un pourcentage de
   * `background-position` ne designe pas le centre de la fenetre : il aligne le point P % de
   * l'IMAGE sur le point P % de la boite, donc il se rapporte au DEBORDEMENT. Poser `cx` tel
   * quel decalerait le cadrage d'autant que l'image deborde, et la galerie montrerait autre
   * chose que la fenetre que le client vient de deplacer.
   */
  function galerieSuit(l, h, fw, fh, cx, cy) {
    if (!galerie) return;
    var vueFixe = galerie.getAttribute("data-framed") === "false" && galerie.getAttribute("data-mockup") !== "true";
    var r = String(l / h);
    galerie.style.setProperty("--art-ratio", r);
    if (piece) piece.style.setProperty("--art-ratio", r);
    /* Les cotes ne s'affichent que sous `data-sized` : c'est l'interrupteur de base.css. */
    if (vueFixe) galerie.setAttribute("data-sized", "false");
    else galerie.setAttribute("data-sized", "true");
    /* ⛔ ET UN SECOND INTERRUPTEUR, POUR LA SCENE ELLE-MEME (Adrien, 23/08/2026 : « l'application
       d'une dimension personnalisee (j'ai mis 140 x 50cm) fait toujours buguer la page
       produit »).
       `data-sized` ne distingue pas un format du catalogue d'une cote saisie a la main. Or les
       quatre formats vendus tiennent tous entre 0,70 et 0,75 de rapport, quand une cote libre en
       vaut n'importe lequel : 2,80 pour 140x50, 0,36 pour 50x140. La scene, elle, portait un
       rapport ECRIT (1054/1492) et une hauteur prise sur l'ecran. Mesure en WebKit, iPhone
       390 px : a 140x50 le cadre faisait 115 px de haut dans une scene de 507, soit 392 px de
       vide autour d'une affiche large comme l'ecran ; a 50x140 il faisait 902 px dans une scene
       de 523 et debordait de 193 px par le bas, PAR-DESSUS le titre et la colonne d'achat,
       puisque `data-sized` leve justement le rognage de la scene.
       ⚠️ CET ATTRIBUT NE VAUT QUE POUR LA COTE LIBRE. Le poser sur `data-sized` aurait change la
       hauteur de la scene sur toutes les fiches du catalogue, pour tous les acheteurs, afin de
       corriger un etat qu'aucune d'elles n'atteint. */
    galerie.setAttribute("data-cote-libre", "true");
    /* ⚠️ « cote-libre » ET SURTOUT PAS « sur-mesure » : la pastille qui ouvre ce panneau porte
       deja `data-sur-mesure`, et la ligne 27 de ce fichier la retrouve par
       `document.querySelector("[data-sur-mesure]")`. Poser le meme nom sur la galerie, qui vient
       AVANT la pastille dans le document, aurait fait rendre la galerie a cette recherche des
       qu'elle serait rejouee. Deux objets, deux noms. */
    var dw = document.getElementById("pdp-dim-w");
    var dh = document.getElementById("pdp-dim-h");
    if (dw) dw.textContent = cmTexte(l);
    if (dh) dh.textContent = cmTexte(h);
    var fond = document.getElementById("pdp-main");
    if (fond && !vueFixe) {
      var px = fw < 1 ? ((cx - fw / 2) / (1 - fw)) * 100 : 50;
      var py = fh < 1 ? ((cy - fh / 2) / (1 - fh)) * 100 : 50;
      fond.style.backgroundPosition = px.toFixed(2) + "% " + py.toFixed(2) + "%";
    }
  }

  /** Retour a un format standard : la scene reprend ce que le gabarit avait ecrit. */
  function galerieRend() {
    if (galerie) {
      galerie.removeAttribute("data-cote-libre");
      if (ratioGalerie) galerie.style.setProperty("--art-ratio", ratioGalerie);
      else galerie.style.removeProperty("--art-ratio");
    }
    if (piece) {
      if (ratioPiece) piece.style.setProperty("--art-ratio", ratioPiece);
      else piece.style.removeProperty("--art-ratio");
    }
    /* Les cotes, elles, sont reecrites par `updateFormatScale` au clic qui nous fait sortir :
       les effacer ici les ferait clignoter, et les laisser fausses est impossible puisque ce
       clic EST un choix de format. */
    var fond = document.getElementById("pdp-main");
    if (fond) fond.style.removeProperty("background-position");
    var artPiece = document.getElementById('pdp-mockup-art');
    if (artPiece) artPiece.style.removeProperty('background-position');
  }

  function montre(on) {
    actif = !!on;
    bloc.hidden = !actif;
    pastille.setAttribute("aria-pressed", actif ? "true" : "false");
    pastille.classList.toggle("is-on", actif);
    /* ⛔ LE CADRE DISPARAIT, IL NE SE GRISE PAS. Un cadre au catalogue existe en quatre cotes ;
       aucune ne correspond a une cote libre, et proposer un choix impossible se paie au SAV. */
    if (cadre) cadre.hidden = actif;
    if (actif) { suitLaSaisie(); demandePrix(); }
    else {
      clearTimeout(minuteur);
      tour += 1;
      prixTtc = null;
      cadrage = { x: 0.5, y: 0.5 };
      retireCouche();
      galerieRend();
      if (libelleCotes) libelleCotes.textContent = texteCotes;
    }
    window.dispatchEvent(new CustomEvent('af:sur-mesure'));
  }

  pastille.addEventListener("click", function () {
    if (panneauDisponible) {
      ouvrePanneau();
      return;
    }
    if (actif) {
      montre(false);
      if (window.__pdpOublierLeFormat) window.__pdpOublierLeFormat();
      return;
    }
    retireLeCadre();
    /* ⛔ ON DESELECTIONNE LES FORMATS STANDARD A LA MAIN. Cette pastille n'a pas de variante :
       `product.js` ne la verra jamais passer, et sans ce geste deux pastilles resteraient
       allumees en meme temps. */
    if (window.__pdpOublierLeFormat) window.__pdpOublierLeFormat();
    var autres = document.querySelectorAll(".pdp-option [data-value]");
    for (var i = 0; i < autres.length; i += 1) autres[i].setAttribute("aria-pressed", "false");
    var apres = document.querySelector("[data-apres-format]");
    if (apres) apres.hidden = false;
    montre(true);
  });

  /* Choisir un format standard rend la main au parcours ordinaire. */
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest(".pdp-option [data-value]")) montre(false);
  });

  /* ⚠️ L'APERCU NE PASSE PAS PAR LE SERVEUR, DONC IL NE SE STABILISE PAS. Il se recalcule a
     chaque touche, la ou le prix attend 260 ms : faire attendre un dessin qui ne coute rien
     donnerait l'impression que le champ ne repond pas. */
  function suitLaSaisie() {
    window.dispatchEvent(new CustomEvent('af:sur-mesure'));
    var l = borne(champL.value);
    var h = borne(champH.value);
    if (l !== null && h !== null) majApercu(l, h);
    if (actualiseCouche) actualiseCouche();
  }
  window.addEventListener('af:bordure', function () {
    if (!actif) return;
    var l = borne(champL.value), h = borne(champH.value);
    if (l !== null && h !== null) majApercu(l, h);
    if (actualiseCouche) actualiseCouche();
  });

  [champL, champH].forEach(function (c) {
    if (!c) return;
    c.addEventListener("input", suitLaSaisie);
    c.addEventListener("input", demandePrix);
    c.addEventListener("change", function () {
      var v = borne(c.value);
      if (v !== null) c.value = v;
      demandePrix();
    });
  });

  /* ============================================================================================
   * LE RECADRAGE DANS LE PLEIN ECRAN (Adrien, 20/08/2026 : « on devrait pouvoir cliquer sur
   * l'image pour agrandir et recadrer aussi dans une modale »).
   *
   * ⛔ IL VIT ICI, PAS DANS `product.js`. Le plein ecran de la fiche est un code delicat : il
   * clone des scenes, jongle avec trois cibles de zoom et une HD differee, et son garde-fou a
   * ete resserre trois fois. Y greffer un mode de plus, c'est le casser pour les 1 590 fiches
   * qui n'ont rien demande. Ce script POSE SA PROPRE COUCHE dans la meme boite et la retire en
   * partant : le plein ecran ordinaire ne sait rien de tout ca.
   *
   * ⛔ ET IL MONTRE SA PROPRE IMAGE, PAS CELLE DU PLEIN ECRAN. Le plein ecran affiche la
   * VIGNETTE CHOISIE : si le client a clique « Salon », il montre la mise en situation. Cadrer
   * sur une photo de salon, c'est cadrer autre chose que ce qui sera imprime.
   * ========================================================================================== */
  var IMG_HD = bloc.getAttribute("data-apercu-hd") || bloc.getAttribute("data-apercu") || "";
  var couche = null;

  function poseCouche(hote) {
    var plein = hote || document.getElementById("pdp-zoom");
    if (!plein || couche) return;
    var img = document.getElementById("pdp-zoom-img");
    var scene = document.getElementById("pdp-zoom-scene");
    if (img) img.hidden = true;
    if (scene) scene.hidden = true;

    couche = document.createElement("div");
    couche.className = "pdp-sm-crop";
    couche.innerHTML = '<div class="pdp-sm-crop__cadre"><div class="pdp-sm-crop__vue"><span class="pdp-sm-crop__fenetre"></span></div></div>'
      + '<p class="pdp-sm-crop__aide sans"></p>';
    var vue = couche.querySelector(".pdp-sm-crop__vue");
    var fen = couche.querySelector(".pdp-sm-crop__fenetre");
    couche.querySelector(".pdp-sm-crop__aide").textContent = bloc.getAttribute("data-cadrer") || "";
    if (IMG_HD) vue.style.backgroundImage = "url('" + IMG_HD + "')";
    vue.style.setProperty("--sm-art", String(RATIO_ART));
    vue.tabIndex = 0;
    vue.setAttribute('role', 'group');
    vue.setAttribute('aria-label', bloc.getAttribute('data-cadrer') || '');
    plein.appendChild(couche);

    function pose() {
      var l = borne(champL.value);
      var h = borne(champH.value);
      if (l === null || h === null) return;
      var z = zone(l, h);
      var fw = z.fw;
      var fh = z.fh;
      var cx = Math.min(Math.max(cadrage.x, fw / 2), 1 - fw / 2);
      var cy = Math.min(Math.max(cadrage.y, fh / 2), 1 - fh / 2);
      fen.style.setProperty("--sm-w", String(fw));
      fen.style.setProperty("--sm-h", String(fh));
      fen.style.setProperty("--sm-x", String(cx));
      fen.style.setProperty("--sm-y", String(cy));
      /* Le rectangle est la zone imprimee ; le contour montre la bordure ajoutee autour. */
      var epaisseur = z.m ? vue.getBoundingClientRect().width * fw * z.m / z.l : 0;
      fen.style.outline = epaisseur + 'px solid ' + (window.AfBordure ? window.AfBordure.fondHex : '#ffffff');
      /* ⚠️ UN AXE SEULEMENT SE DEPLACE, ET C'EST GEOMETRIQUE : la fenetre remplit deja l'autre.
         Le curseur le dit, sinon le client tire dans une direction qui ne repond pas et croit
         que rien ne marche. */
      couche.setAttribute("data-axe", fh < 1 ? "y" : (fw < 1 ? "x" : "aucun"));
      return { fw: fw, fh: fh };
    }
    var geo = pose();
    actualiseCouche = pose;

    vue.addEventListener('keydown', function (e) {
      var deplacements = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
      var d = deplacements[e.key];
      if (!d) return;
      var z = zone(borne(champL.value), borne(champH.value));
      cadrage.x = z.cx + d[0] * (e.shiftKey ? 0.05 : 0.01);
      cadrage.y = z.cy + d[1] * (e.shiftKey ? 0.05 : 0.01);
      z = zone(borne(champL.value), borne(champH.value));
      cadrage.x = z.cx;
      cadrage.y = z.cy;
      suitLaSaisie();
      e.preventDefault();
    });

    var glisse = false;
    var prise = { x: 0, y: 0 };
    function fractions(e) {
      var r = vue.getBoundingClientRect();
      return { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height };
    }
    vue.addEventListener("pointerdown", function (e) {
      geo = pose(); if (!geo) return;
      glisse = true;
      var f = fractions(e);
      /* ⚠️ ON SAISIT LA FENETRE, ON NE LA TELEPORTE PAS SOUS LE DOIGT. Recentrer sur le point
         touche fait sauter l'image au premier contact, et le client perd le cadrage qu'il
         venait de regarder. */
      prise.x = f.x - cadrage.x;
      prise.y = f.y - cadrage.y;
      try { vue.setPointerCapture(e.pointerId); } catch (err) { /* sans capture, on suit quand meme */ }
      e.preventDefault();
    });
    vue.addEventListener("pointermove", function (e) {
      if (!glisse || !geo) return;
      var f = fractions(e);
      cadrage.x = Math.min(Math.max(f.x - prise.x, geo.fw / 2), 1 - geo.fw / 2);
      cadrage.y = Math.min(Math.max(f.y - prise.y, geo.fh / 2), 1 - geo.fh / 2);
      pose();
      e.preventDefault();
    });
    var lache = function () { glisse = false; suitLaSaisie(); };
    vue.addEventListener("pointerup", lache);
    vue.addEventListener("pointercancel", lache);
    /* ⛔ LE PLEIN ECRAN SE FERME AU CLIC, ET IL SE FERMAIT DONC A CHAQUE FIN DE GLISSEMENT.
       `product.js` ecoute le clic sur la boite entiere : sans cette barriere, le client lachait
       la fenetre et l'ecran se refermait sur lui. Le clic HORS de la couche, lui, ferme
       toujours : c'est la sortie normale, et on n'y touche pas. */
    couche.addEventListener("click", function (e) { e.stopPropagation(); });
    /* ⚠️ ET LA MOLETTE NE GROSSIT PLUS RIEN : elle agirait sur l'image du plein ecran, que
       nous venons de cacher, et la couche se retrouverait a cote d'une image invisible agrandie. */
    couche.addEventListener("wheel", function (e) { e.stopPropagation(); }, { passive: true });
  }

  function retireCouche() {
    if (couche && couche.parentNode) couche.parentNode.removeChild(couche);
    couche = null;
    actualiseCouche = null;
    var img = document.getElementById("pdp-zoom-img");
    var scene = document.getElementById("pdp-zoom-scene");
    /* On rend le plein ecran tel qu'on l'a trouve : `product.js` gere ses propres etats, et une
       image laissee cachee ferait un plein ecran vide a la fiche suivante. */
    if (img) img.hidden = false;
    if (scene && scene.children.length) scene.hidden = false;
  }

  function construitPanneau() {
    if (panneau) return;
    panneau = document.createElement('dialog');
    panneau.id = 'pdp-sm-dialog';
    panneau.className = 'pdp-configurator pdp-sm-dialog';
    panneau.setAttribute('aria-labelledby', 'pdp-sm-dialog-title');
    panneau.innerHTML = '<header class="pdp-sm-dialog__head"><h2 id="pdp-sm-dialog-title" tabindex="-1" autofocus></h2><button type="button" class="pdp-sm-dialog__close"><span aria-hidden="true">×</span></button></header>' +
      '<div class="pdp-sm-dialog__body"><div class="pdp-sm-dialog__options"></div><div class="pdp-sm-dialog__crop"></div></div>' +
      '<footer class="pdp-sm-dialog__footer"><div class="pdp-sm-dialog__actions"><button type="button" class="pdp-sm-dialog__reset"></button><button type="button" class="pdp-sm-dialog__apply"></button></div></footer>';
    panneau.querySelector('h2').textContent = bloc.dataset.sheetTitle;
    var fermer = panneau.querySelector('.pdp-sm-dialog__close');
    fermer.setAttribute('aria-label', bloc.dataset.sheetClose);
    fermer.addEventListener('click', function () { fermePanneau(false); });
    var recentrer = panneau.querySelector('.pdp-sm-dialog__reset');
    recentrer.textContent = bloc.dataset.sheetReset;
    recentrer.addEventListener('click', function () { cadrage = { x: 0.5, y: 0.5 }; suitLaSaisie(); });
    appliquer = panneau.querySelector('.pdp-sm-dialog__apply');
    appliquer.textContent = bloc.dataset.sheetApply;
    appliquer.addEventListener('click', function () {
      if (!champL.reportValidity() || !champH.reportValidity() || prixTtc === null) return;
      if (libelleCotes) libelleCotes.textContent = champL.value + ' × ' + champH.value + ' cm';
      fermePanneau(true);
    });
    panneau.querySelector('.pdp-sm-dialog__body').prepend(bloc);
    panneau.querySelector('.pdp-sm-dialog__footer').prepend(sortie);
    document.body.append(panneau);
    pastille.setAttribute('aria-haspopup', 'dialog');
    pastille.setAttribute('aria-controls', panneau.id);
    libelleCotes = pastille.querySelector('span:not(.pdp-size-visual):not(.opt-pill__top)');
    if (libelleCotes) texteCotes = libelleCotes.textContent;
    panneau.addEventListener('cancel', function (e) { e.preventDefault(); fermePanneau(false); });
    var dehors = false;
    function horsPanneau(e) {
      var r = panneau.getBoundingClientRect();
      return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    }
    panneau.addEventListener('pointerdown', function (e) { dehors = e.target === panneau && horsPanneau(e); });
    panneau.addEventListener('click', function (e) {
      if (dehors && e.target === panneau && horsPanneau(e)) fermePanneau(false);
      dehors = false;
    });
    panneau.addEventListener('close', function () {
      retireCouche();
      if (placeBordure && bordure) placeBordure.after(bordure);
      document.documentElement.style.overflow = scrollPanneau.html;
      document.body.style.overflow = scrollPanneau.body;
      if (panneau.returnValue !== 'apply' && avantPanneau) {
        if (bordure) {
          var choixAvant = bordure.querySelector('.pdp-bordure__btn[data-bordure="' + avantPanneau.bordure + '"]');
          if (choixAvant) choixAvant.click();
          var fondAvant = bordure.querySelector('[data-bordure-fond="' + avantPanneau.fond + '"]');
          if (fondAvant) fondAvant.click();
        }
        champL.value = avantPanneau.l;
        champH.value = avantPanneau.h;
        cadrage = avantPanneau.cadrage;
        if (avantPanneau.actif) { suitLaSaisie(); demandePrix(); }
        else {
          montre(false);
          if (avantPanneau.standard) avantPanneau.standard.click();
          else if (window.__pdpOublierLeFormat) window.__pdpOublierLeFormat();
          /* Le configurateur reactive les cadres dans un MutationObserver apres le format.
             Attendre ce recalcul, sinon le clic sur une pastille encore disabled est perdu. */
          var cadreARestaurer = avantPanneau.cadre;
          var formatARestaurer = avantPanneau.standard;
          if (cadreARestaurer) setTimeout(function () {
            if (!actif && formatARestaurer && formatARestaurer.getAttribute('aria-pressed') === 'true' &&
              !cadreARestaurer.disabled && cadreARestaurer.getAttribute('aria-pressed') !== 'true') cadreARestaurer.click();
          }, 0);
        }
      }
      avantPanneau = null;
      pastille.focus({ preventScroll: true });
    });
  }

  function ouvrePanneau() {
    construitPanneau();
    if (panneau.open) return;
    avantPanneau = { actif: actif, l: champL.value, h: champH.value, cadrage: { x: cadrage.x, y: cadrage.y },
      bordure: window.AfBordure ? window.AfBordure.choisi : 'sans',
      fond: window.AfBordure ? window.AfBordure.fond : '',
      standard: document.querySelector('.pdp-option [data-value][aria-pressed="true"]'),
      cadre: document.querySelector('#pdp-up-frame .pdp-up-color[aria-pressed="true"]') };
    if (!actif) {
      retireLeCadre();
      if (window.__pdpOublierLeFormat) window.__pdpOublierLeFormat();
      document.querySelectorAll('.pdp-option [data-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      var apres = document.querySelector('[data-apres-format]');
      if (apres) apres.hidden = false;
      montre(true);
    }
    scrollPanneau = { html: document.documentElement.style.overflow, body: document.body.style.overflow };
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    panneau.returnValue = '';
    panneau.classList.remove('is-closing');
    if (bordure) {
      if (!placeBordure) { placeBordure = document.createComment('bordure-sur-mesure'); bordure.before(placeBordure); }
      panneau.querySelector('.pdp-sm-dialog__options').appendChild(bordure);
      window.dispatchEvent(new CustomEvent('af:sur-mesure'));
    }
    panneau.showModal();
    retireCouche();
    poseCouche(panneau.querySelector('.pdp-sm-dialog__crop'));
    majBouton();
    panneau.querySelector('h2').focus({ preventScroll: true });
  }

  function fermePanneau(valide) {
    if (!panneau || !panneau.open || fermeturePanneau) return;
    appliquer.disabled = true;
    panneau.classList.add('is-closing');
    fermeturePanneau = setTimeout(function () {
      fermeturePanneau = 0;
      panneau.close(valide ? 'apply' : 'cancel');
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
  }

  /* Le plein ecran s'ouvre par `product.js` : on regarde son attribut plutot que de dupliquer
     ses declencheurs, qui ont trois formes et un garde-fou resserre trois fois. */
  /* ⛔ LA VIGNETTE D'APERCU OUVRE LA MODALE (Adrien, 21/08/2026). J'avais mis l'invitation sous
     l'image de la fiche : au mauvais endroit, et loin de la seule chose qu'elle concerne.
     ⚠️ ELLE PASSE PAR `#pdp-stage`, ou `product.js` ecoute deja. Rappeler `open()` d'ici
     demanderait de recopier son garde-fou, celui qui a ete resserre trois fois : deux copies
     d'une regle de securite, c'est la seconde qui cede. */
  var boutonZoom = bloc.querySelector("[data-sm-zoom]");
  if (boutonZoom) {
    boutonZoom.addEventListener("click", function () {
      var scene = document.getElementById("pdp-stage");
      if (scene) scene.click();
    });
  }

  var plein = document.getElementById("pdp-zoom");
  if (plein && window.MutationObserver) {
    new MutationObserver(function () {
      if (plein.hidden) retireCouche();
      else if (actif) poseCouche();
    }).observe(plein, { attributes: true, attributeFilter: ["hidden"] });
  }

  /* ⛔ L'INTERCEPTION EST EN CAPTURE SUR LE DOCUMENT, comme celle du pele-mele : un ecouteur
     pose sur le bouton passerait APRES celui de `product.js`, qui aurait deja tente d'ajouter
     une variante qui n'existe pas. */
  document.addEventListener("click", function (e) {
    if (!actif || !e.target || !e.target.closest) return;
    if (!e.target.closest("#pdp-add, #pdp-sticky-add")) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    ajoute();
  }, true);

  function ajoute() {
    var l = borne(champL.value);
    var h = borne(champH.value);
    if (l === null || h === null || prixTtc === null) { demandePrix(); return; }
    var support = bloc.getAttribute("data-support") || "tirage-sur-mesure";
    var racine = String(window.MURMURE_RACINE || "/").replace(/\/$/, "");
    /* ⛔ LE PALIER SE CHOISIT AU-DESSUS, JAMAIS AU-DESSOUS. Le prix rendu par le serveur tient
       deja le plancher de marge : descendre au palier inferieur le franchirait, et un plancher
       qu'on franchit n'en est pas un.
       ⛔⛔ ET LA COMPARAISON SE FAIT DANS UNE SEULE DEVISE. `v.price` vient de Shopify, donc en
       monnaie du marche ; `prixTtc` vient de NOTRE serveur, donc en euros. Compares tels quels
       sur /cs-eun/, un 60 × 90 a 31 € cherchait le premier palier au-dessus de 3 100 halerus,
       soit 31 Kč : le client tcheque partait au paiement avec un tirage 60 × 90 a 1,26 €, et
       Shopify l'aurait encaisse sans rien signaler. Ce n'etait plus un affichage faux, c'etait
       une vente a perte. Mesure du 21/08/2026, avec l'affichage du meme defaut. */
    fetch(racine + "/products/" + support + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var choix = null;
        var seuilPalier = enDevise(Math.round(prixTtc * 100));
        (prod.variants || []).forEach(function (v) {
          if (v.price >= seuilPalier && (!choix || v.price < choix.price)) choix = v;
        });
        if (!choix) throw new Error("aucun palier");
        return window.murAddToCart
          ? window.murAddToCart({ items: [ligne(choix, l, h)] })
          : fetch(racine + "/cart/add.js", {
            method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [ligne(choix, l, h)] }),
          }).then(function () { if (window.murRefreshCart) return window.murRefreshCart(); });
      })
      .catch(function () {
        /* ⛔ LE MESSAGE D'ECHEC EST TRADUIT, ET IL SE LIT SUR LE BLOC. Il se lisait sur
           `#pdp-sm-prix`, qui ne porte pas cet attribut : le repli francais en dur partait donc
           TOUJOURS, y compris devant un client neerlandais, au moment precis ou il vient de
           cliquer « ajouter au panier » et ou plus rien ne se passe. */
        if (window.murToast) window.murToast(bloc.getAttribute("data-echec") || "");
      });
  }

  function ligne(variante, l, h) {
    var props = {};
    if (bordure && !bordure.hidden) bordure.querySelectorAll('[name]').forEach(function(champ) {
      var nom = /^properties\[(.+)\]$/.exec(champ.name);
      if (nom && champ.value && !champ.closest('[hidden]')) props[nom[1]] = champ.value;
    });
    /* ⛔ LES PROPRIETES SOULIGNEES SONT MASQUEES AU CLIENT, comme `_perso` et `_b2b_produit` :
       elles servent au webhook et a l'atelier, pas au panier. La cote lisible, elle, n'a pas de
       souligne : c'est la seule que le client doit voir. */
    props["_sm_produit"] = PRODUIT;
    props["_sm_l"] = String(l);
    props["_sm_h"] = String(h);
    /* Le cadrage, seulement s'il a bouge : une propriete « 0.5 » sur toutes les lignes ne dirait
       rien de plus que son absence, et elle s'afficherait dans le panier des qu'un jour on
       oublierait le souligne. */
    if (cadrage.x !== 0.5 || cadrage.y !== 0.5) {
      props["_sm_cx"] = cadrage.x.toFixed(4);
      props["_sm_cy"] = cadrage.y.toFixed(4);
    }
    /* ⛔ LA VIGNETTE ET LE LIEN DE LA LIGNE, parce que la ligne porte le produit-support, qui
       n'a ni image ni page a montrer. Sans eux, le panier affichait un carre vide et un lien
       vers une fiche technique, juste avant le paiement : le client ne pouvait plus verifier
       quelle affiche il achetait. Meme geste que `_perso_preview` pour les personnalisations.
       ⚠️ ET LE PANIER NE LES CROIT PAS SUR PAROLE : une propriete de ligne est ECRITE PAR
       L'ACHETEUR (n'importe qui peut poster vers /cart/add.js), donc les deux ecrans verifient
       la forme avant d'en faire un `src` ou un `href`. Ce qui est ecrit ici est une commodite,
       pas une autorisation. */
    props["_sm_image"] = bloc.getAttribute("data-apercu") || "";
    props["_sm_url"] = bloc.getAttribute("data-url") || "";
    var titre = document.getElementById("pdp-title");
    props[bloc.getAttribute("data-libelle-cote") || "Dimensions"] = l + " × " + h + " cm";
    if (titre) props[bloc.getAttribute("data-libelle-affiche") || "Affiche"] = titre.textContent.trim();
    return { id: variante.id, quantity: 1, properties: props };
  }
})();
